import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/pointCardLogs/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/pointCardLogs/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/pointCardLogs/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/pointCardLogs/delete',
    method: 'post',
    data
  })
}

